/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_ReportsInputs */

const en_portalframe_reports = /** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports`)
};

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const ar_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const he_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const ur_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const es_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const fr_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const de_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const pt_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const hi_portalframe_reports = en_portalframe_reports;

/** @type {(inputs: Portalframe_ReportsInputs) => LocalizedString} */
const bn_portalframe_reports = en_portalframe_reports;

/**
* | output |
* | --- |
* | "Reports" |
*
* @param {Portalframe_ReportsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_reports = /** @type {((inputs?: Portalframe_ReportsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_ReportsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_reports(inputs)
	if (locale === "he") return he_portalframe_reports(inputs)
	if (locale === "ur") return ur_portalframe_reports(inputs)
	if (locale === "es") return es_portalframe_reports(inputs)
	if (locale === "fr") return fr_portalframe_reports(inputs)
	if (locale === "de") return de_portalframe_reports(inputs)
	if (locale === "pt") return pt_portalframe_reports(inputs)
	if (locale === "hi") return hi_portalframe_reports(inputs)
	if (locale === "bn") return bn_portalframe_reports(inputs)
	return /** @type {LocalizedString} */ ("Reports")
});